import { render } from "./page-gestion-livraison.vue?vue&type=template&id=ba95af2a"
import script from "./page-gestion-livraison.vue?vue&type=script&lang=js"
export * from "./page-gestion-livraison.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\cbetta\\Desktop\\workspace\\Developpement\\hub-web-apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__